import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const ArrowLeftIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9088 10.708L12.1963 6.42048C12.5346 6.0822 12.5346 5.53375 12.1963 5.19548C11.858 4.8572 11.3096 4.8572 10.9713 5.19548L5.29091 10.8759C4.90038 11.2664 4.90039 11.8996 5.29091 12.2901L10.9713 17.9705C11.3096 18.3088 11.858 18.3088 12.1963 17.9705C12.5346 17.6322 12.5346 17.0838 12.1963 16.7455L7.9088 12.458H17.7088C18.1921 12.458 18.5838 12.0662 18.5838 11.583C18.5838 11.0997 18.1921 10.708 17.7088 10.708H7.9088Z"
      />
    </Icon>
  );
};
